// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"af1e1ed4","199":"887d15c1","631":"59611432","640":"90432d3d","664":"0861a51f"}[chunkId] + ".chunk.js";
};